import { Box, Typography, Grid, Button, TextField, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { TypeAnomalias } from '../../../../../pages/Reports/Risrot/RegisterRisrot';
import { useMemo } from 'react';
import { Add } from '@mui/icons-material';

interface BoxImagensProps {
	estrutura: string;
	imagens: TypeAnomalias['imagens'];
	onUpdateImagens: (estrutura: string, imagens: TypeAnomalias['imagens']) => void;
	disabled: boolean;
	data_inspecao: string;
	hora_fim_inspecao: string;
}

interface Imagem {
	data: string;
	date: string;
	legenda: string;
	nome: string;
}

export default function BoxImagens({
	estrutura,
	imagens,
	onUpdateImagens,
	disabled,
	data_inspecao,
	hora_fim_inspecao
}: BoxImagensProps) {

	// useEffect(() => {
	// 	console.log(`[${estrutura}] Props recebidas:`, {
	// 		totalImagens: imagens?.length || 0,
	// 		disabled,
	// 		imagens: imagens
	// 	});
	// }, [imagens, disabled, estrutura]);

	const isImagemExistente = (img: Imagem | null): boolean => {
		if (!img) return false;
		if(disabled){
			return true;
		}else{
			return (img.data.includes('https://s3'));
		}
	};

	const imagensParaExibir = useMemo(() => {
		if (!imagens || imagens.length === 0) return [];

		if (disabled) {
			const normalized = imagens.map(img => {
				if (!img?.date) return img;
				const hasTime = /\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(img.date);
				return {
					...img,
					date: hasTime ? img.date : `${img.date} 00:00`,
				};
			});

			const timestampInspecao = new Date(
				`${data_inspecao} ${hora_fim_inspecao}`
			).getTime();

			return normalized
				.filter(img => {
					if (!img?.date) return false;
					const ts = new Date(img.date).getTime();
					return ts <= timestampInspecao;
				})
				.sort((a, b) => {
					return new Date(b.date).getTime() - new Date(a.date).getTime();
				});
		} else {
			const novas = imagens.filter(img => img && !isImagemExistente(img));
			return novas;
		}
	}, [imagens, disabled, data_inspecao, hora_fim_inspecao, estrutura]);

	const handleImageChange = (file: File | null) => {
		if (!(file instanceof Blob)) {
			console.error('O parâmetro não é um Blob válido');
			return;
		}
		if (!file) return;

		const data_inteira = `${data_inspecao} ${hora_fim_inspecao}`;
		const reader = new FileReader();

		reader.onloadend = () => {
			const novaImagem: Imagem = {
				data: reader.result as string,
				nome: file.name,
				date: data_inteira,
				legenda: '',
			};
			const imagensAtuais = imagens || [];
			const newImagens = [...imagensAtuais, novaImagem];
			onUpdateImagens(estrutura, newImagens);
		};
		reader.readAsDataURL(file);
	};

	const handleFieldChange = (index: number, campo: 'legenda', valor: string) => {
		const newImagens = [...(imagens || [])];
		if (newImagens[index]) {
			newImagens[index] = {
				...newImagens[index],
				[campo]: valor,
			};
		}
		onUpdateImagens(estrutura, newImagens);
	};

	const handleRemoveImage = (indexToRemove: number) => {
		const newImagens = (imagens || []).filter((_, index) => index !== indexToRemove);
		onUpdateImagens(estrutura, newImagens);
	};

	return (
		<Box mt={4}>
			{!disabled && (
				<Button
					variant="contained"
					component="label"
					sx={{ mt: 2, mb: 2 }}
					startIcon={<Add />}
				>
					Adicionar Imagem
					<input
						type="file"
						accept="image/*"
						hidden
						onChange={(e) => handleImageChange(e.target.files?.[0] || null)}
					/>
				</Button>
			)}

			<Grid container spacing={2}>
				{imagensParaExibir.map((img, displayIndex) => {
					const realIndex = imagens.findIndex(i => i === img);

					return (
						<Grid item xs={12} md={4} key={realIndex}>
							<Box border={1} borderRadius={2} p={2} position="relative">
								{img?.data ? (
									<>
										<img
											src={img.data}
											alt={`Imagem ${displayIndex + 1}`}
											style={{ width: '100%', height: '200px', objectFit: 'cover' }}
										/>
										{!disabled && (
											<IconButton
												onClick={() => handleRemoveImage(realIndex)}
												sx={{
													position: 'absolute',
													top: 8,
													right: 8,
													bgcolor: 'rgba(255, 255, 255, 0.8)',
													'&:hover': {
														bgcolor: 'rgba(255, 255, 255, 0.95)',
													},
												}}
												size="small"
											>
												<DeleteIcon />
											</IconButton>
										)}
									</>
								) : (
									<Box
										sx={{
											width: '100%',
											height: 200,
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
											bgcolor: '#f5f5f5',
											borderRadius: 2,
										}}
									>
										<Typography color="textSecondary">Sem imagem</Typography>
									</Box>
								)}

								<TextField
									label="Legenda"
									value={img?.legenda || ''}
									onChange={(e) =>
										handleFieldChange(realIndex, 'legenda', e.target.value)
									}
									fullWidth
									disabled={disabled}
									sx={{ mt: 2 }}
								/>

								{disabled && img?.date && (
									<Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: 'block' }}>
										Data: {new Date(img.date).toLocaleString('pt-BR')}
									</Typography>
								)}
							</Box>
						</Grid>
					);
				})}

				{imagensParaExibir.length === 0 && (
					<Grid item xs={12}>
						<Typography color="textSecondary" align="center">
							{disabled ? 'Nenhuma imagem disponível' : 'Adicione imagens usando o botão acima'}
						</Typography>
					</Grid>
				)}
			</Grid>
		</Box>
	);
}